import { Link, NavLink } from "react-router-dom";
import { BadgeCheck } from "lucide-react";

const nav = [
  { to: "/", label: "Recensioni", id: "nav-reviews" },
  { to: "/garanzia", label: "Garanzia", id: "nav-guarantee" },
  { to: "/garanzia/stato", label: "Stato pratica", short: "Pratica", id: "nav-claim-status" },
];

export const PublicShell = ({ children }) => (
  <div className="min-h-screen bg-[#F9FAFB] text-gray-900 grain">
    <header className="sticky top-0 z-40 bg-[#0584D5] border-b border-[#016AAE] text-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3" data-testid="public-logo-link">
          <img src="/img/rocard-logo.png" alt="Rocard" className="h-9 sm:h-10 w-auto" />
          <span className="hidden sm:inline-flex items-center gap-1 text-xs font-semibold text-white bg-white/15 border border-white/25 px-2 py-0.5 rounded-full">
            <BadgeCheck size={13} /> Recensioni verificate
          </span>
        </Link>
        <nav className="flex items-center gap-0.5 sm:gap-2">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end
              data-testid={n.id}
              className={({ isActive }) =>
                `px-2.5 sm:px-3 py-1.5 rounded-full whitespace-nowrap text-xs sm:text-sm transition-colors duration-200 ${isActive ? "bg-white text-[#0584D5] font-semibold" : "text-white/90 hover:bg-white/15"}`
              }
            >
              {n.short ? <><span className="sm:hidden">{n.short}</span><span className="hidden sm:inline">{n.label}</span></> : n.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
    <main>{children}</main>
    <footer className="border-t border-gray-200 bg-white mt-24">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row sm:items-center justify-between gap-6 text-sm text-gray-600">
        <img src="/img/rocard-logo-blue.png" alt="Rocard" className="h-8 w-auto self-start sm:self-center" />
        <p className="max-w-xl">Le recensioni provengono solo da clienti con un ordine verificato e sono moderate secondo criteri trasparenti.</p>
        <a href="https://www.rocard.it" className="font-semibold text-emerald-900 hover:underline" data-testid="footer-shop-link">
          Vai al negozio →
        </a>
      </div>
    </footer>
  </div>
);
